export default {
  calendar: {
    absences: 101133, // Absences
    acceptShift: 103280, // Accept Shift
    calendar: 70005, // Calendar
    cancelRequest: 101558, // Cancel Request
    controlWhetherYouReceiveNotificationsViaEmailRegardingShift: 103286, // Control whether you receive notifications via email regarding shift offering
    declineShift: 103279, // Decline Shift
    department: 95808, // Department
    employee: 45148, // Employee
    exportToPdf: 95610, // Export to PDF
    myCalendar: 101544, // My calendar
    myPeersSchedules: 103284, // My Peers Schedules
    mySchedule: 103285, // My Schedule
    noScheduledDepartmentsToShow: 101563, // No scheduled departments to show!
    noScheduledJobsToShow: 101557, // No scheduled jobs to show!
    notPublished: 101572, // Not Published
    noteFromManager: 103283, // Note From Manager
    offeredShift: 103278, // Offered shift
    offeredShifts: 103287, // Offered Shifts
    pendingAbsenceRequest: 101553, // Pending Absence Request
    qualification: 57213, // Qualification
    rejectedAbsenceRequest: 101559, // Rejected Absence Request
    rule: 45606, // Rule
    schedule: 81617, // Schedule
    scheduleDetails: 101135, // Schedule Details
    scheduleNote: 80796, // Schedule Note
    scheduledDepartments: 101561, // Scheduled departments
    scheduledJobs: 101562, // Scheduled jobs
    schedules: 95913, // Schedules
    shift: 45607, // Shift
    shiftOffer: 103147, // Shift Offer
    thisShiftOfferWindowHasExpired: 103281, // This shift offer window has expired
    viewFullCalendar: 101545, // View full calendar
    youHaveAcceptedThisShiftOfferItIsAwaiting: 103282, // You have accepted this shift offer. It is awaiting manager approval.
    youHaveSucessfullyAcceptedTheShift: 103276, // You have sucessfully accepted the shift
    youHaveSucessfullyDeclinedTheShift: 103277, // You have sucessfully declined the shift
  },
};
